import { Component, OnInit, Inject, ViewChild, EventEmitter, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Servicio } from 'app/entities/servicio';
import { InformesService } from '../../services/informes.service';
import { MAT_DIALOG_DATA } from '@angular/material';
import { Subject } from 'rxjs';
import swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-servicios-iass-auditoria',
  templateUrl: './servicios-iass-auditoria.component.html',
  styleUrls: ['./servicios-iass-auditoria.component.scss']
})
export class ServiciosIassAuditoriaComponent implements OnInit,OnDestroy {
  public servicios:Array<Servicio>
  public title:string;
  public trigger:Subject<void>;
  public opciones;
  @ViewChild(DataTableDirective,{static:false}) tabla:DataTableDirective;
  /**
   * Primer función al llamarse al crearse la instancia de ServiciosIassAuditoríaComponent
   */
  constructor(private _informes:InformesService, @Inject(MAT_DIALOG_DATA) private data, private ref:ChangeDetectorRef) {
    this.opciones = {
      columns:[
        {
          title:'CSC',
          data:'Consecutivo'
        },
        {
          title:'Nombre',
          data:'Nombre'
        },
        {
          title:'Doc',
          data:'Documento'
        },
        {
          title:'Fijo',
          data:'telFijo'
        },
        {
          title:'Celular',
          data:'telCelular'
        },
        {
          title:'Llamada',
          data:'telLlamada'
        },
        {
          title:'Medico',
          data:'Medico'
        },
        {
          title:'Enfermero',
          data:'Enfermero'
        },
        {
          title:'Observaciones',
          data:'Observaciones'
        },
        {
          title:'Auditor Observ',
          data:'AuditoriaObserv'
        },
        {
          title:'Estado Caso',
          data:'EstadoCaso'
        },
      ],
      lengthChange:false,
      pageLength:5
    };
    this.trigger = new Subject();
    this.update();
    this.title = this.data.tratamiento;
  }
  
  ngOnInit() {
    const fecha1 = this.data.fecha1; 
    const fecha2 = this.data.fecha2;
    console.log(this.data.lista)
    if(this.data.lista == "requeridos"){
      this._informes.serviciosRequiredsByTratamiento(this.title,fecha1,fecha2).subscribe((servicios:Array<Servicio>)=>{
        this.servicios = servicios;
        this.trigger.next()
      })
    }else{
      this._informes.serviciosObservedByTratamiento(this.title,fecha1,fecha2).subscribe((servicios:Array<Servicio>)=>{
        this.servicios = servicios;
        this.trigger.next()
      })
    }
  }
  cambiarSeguimiento(enseguimiento){
    swal.fire({
      input:'select',
      inputOptions:{
        '1':'Requerido',
        '2':'No requerido'
      },
      title:'A que estado desea cambiar el seguimiento de este tratamiento?',
      inputClass:'form-control full-width',
      showCancelButton:true,
      cancelButtonColor:'#d33'
    })
  }

  /**
   * @flag hace referencia a si el tratamiento es 1 o dos para saber si actualizar el procedimientoObserv o procedimientoObserv2 
   * @csc es la llave primaria de los servicios
   */
  public asignarEstadoCaso(csc:string,flag:1|2){
    console.log("clcik")
    swal.fire({
      title:'En que estado desea dejar este caso?',
      input:'select',
      inputOptions:{
        "1":"cerrado",
        "2":'abierto',
      },
      confirmButtonClass:'btn btn-success',
      showCancelButton:true,
      cancelButtonClass:'btn btn-danger'
    }).then(succ=>{
      if(!succ.dismiss){
        this._informes.setAuditCaseState(csc,flag,succ.value).subscribe(response=>{
          if(response){
            swal.fire({
              type:'success',
              title:'Se actualizó satisfactoriamente la observación del servicio'
            }).then(()=>{
              this.update()
            })
          }
        })
      }
    })
  }

  /**
   * @flag hace referencia a si el tratamiento es 1 o dos para saber si actualizar el procedimientoObserv o procedimientoObserv2 
   * @csc es la llave primaria de los servicios
   */
  public asignarObservacionAudit(csc:string,flag:1 | 2,index){
    
    swal.fire({
      title:'Ingrese la observación que dejará a este tratamiento',
      input:'textarea',
      inputPlaceholder:'Observacion:',
      confirmButtonClass:'btn btn-success',
      showCancelButton:true,
      cancelButtonClass:'btn btn-danger'
    }).then(succ=>{
      if(!succ.dismiss){
        this._informes.setAuditObservation(csc,flag,succ.value).subscribe(response=>{
          if(response){
            swal.fire({
              type:'success',
              title:'Se actualizó satisfactoriamente la observación del servicio'
            }).then(()=>{
              this.update()
            })
          }
        })
      }
    })
  }
  ngOnDestroy(){
    this.trigger.unsubscribe() 
  }


  private async update(){
    let tabla:DataTables.Api
    try{
      tabla = await this.tabla.dtInstance;
      
      const fecha1 = this.data.fecha1; 
      const fecha2 = this.data.fecha2;
      console.log(this.data.lista)
      if(this.data.lista == "requerido"){
        this._informes.serviciosRequiredsByTratamiento(this.title,fecha1,fecha2).subscribe((servicios:Array<Servicio>)=>{
          tabla.destroy();
          this.servicios = servicios;
          this.trigger.next()
        })
      }else{
        this._informes.serviciosObservedByTratamiento(this.title,fecha1,fecha2).subscribe((servicios:Array<Servicio>)=>{
          tabla.destroy();
          this.servicios = servicios;
          this.trigger.next()
        })
      }
    }catch(e){
      return;
    }
  }
}
